import styled from 'styled-components';

export const Item = styled.li`
  position: relative;
  padding-top: 15px;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 1px;
  line-height: 23.4px;
  text-transform: uppercase;
  color: rgba(34, 34, 40, 0.5);
  transition: color 0.25s ease;

  &.active {
    color: #222228;
    &:before {
      background-color: #222228;
    }
  }

  &:before {
    content: '';
    position: absolute;
    top: 0px;
    left: 50%;
    width: 8px;
    height: 8px;
    background-color: #d0d2d3;
    border-radius: 50%;
    transform: translate(-50%, 0);
    transition: background-color 0.25s ease;
  }

  &:hover {
    cursor: pointer;
  }
`;



// WEBPACK FOOTER //
// ./src/components/Auth0Animation/components/BottomNavItem/styled.js